import { dispatch } from 'state/store'
import { fetchPortfolios } from './thunks/fetchPortfolios'
import { fetchMeta } from './thunks/fetchMeta'
import { resetPortfolio } from './slices/user/portfolio'
import { fetchBrokers } from './thunks/fetchBrokers'
import { fetchWalletBalances } from './thunks/fetchWalletBalances'
import { resetWalletBalances } from './slices/user/walletBalances'
import { fetchPriceHistories } from './thunks/fetchPriceHistories'
import { fetchActiveUserHistory } from './thunks/fetchActiveUserHistory'
import { fetchAllBrokersHistory } from './thunks/fetchAllBrokersHistory'
import { fetchAllUsersHistory } from './thunks/fetchAllUsersHistory'
import { isEmptyOrNil } from 'toolbox/account'
import { fetchPointsTotals } from './thunks/fetchPointsTotals'
import { fetchReferralCode } from './thunks/fetchReferralCode'
import { fetchReferralsByUser } from './thunks/fetchReferralsByUser'
import { resetReferralCode } from './slices/user/referral'
import { resetReferralsByUser } from './slices/user/referralsByUser'

export function fetchAppData() {
  console.log('fetching app data...')
  dispatch(fetchMeta())
  dispatch(fetchBrokers())
}

export function fetchAllUsersHistoryData() {
  dispatch(fetchAllUsersHistory())
}

export function fetchAllBrokersHistoryData() {
  dispatch(fetchAllBrokersHistory())
}

export function fetchActiveUserHistoryData(brokerNames: string[], userAddress: string) {
  dispatch(fetchActiveUserHistory({ brokerNames, userAddress }))
}

export function fetchHistoriesPrice(instrumentNames: string[]) {
  dispatch(fetchPriceHistories({ instrumentNames }))
}

export function fetchPortUser(address: string) {
  dispatch(fetchPortfolios({ address }))
}

export function resetUserData() {
  dispatch(resetPortfolio())
  dispatch(resetWalletBalances())
  dispatch(resetReferralCode())
  dispatch(resetReferralsByUser())
}

export function postTransactionRefresh(address: string, brokerNames?: string[]) {
  fetchAppData()
  fetchPortUser(address)
  fetchUserWalletBalances(address)
  if (!isEmptyOrNil(brokerNames)) {
    fetchActiveUserHistoryData(brokerNames, address)
  }
}

export function fetchUserWalletBalances(address: string) {
  dispatch(fetchWalletBalances({ address }))
}

export function fetchPoints() {
  dispatch(fetchPointsTotals())
}

export function fetchCode(address: string) {
  dispatch(fetchReferralCode({ address }))
  dispatch(fetchReferralsByUser({ address }))
}
